<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
					<span class="navigation-title">{{$t('create-document')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form enctype="multipart/form-data" novalidate>
					<div class="container">
						<div class="content">
							<div class="dropbox">
								<input type="file" multiple name="documents" @change="handleFilesUpload($event.target, $event.target.name, $event.target.files);"
								accept="application/pdf" class="input-file">
								<p v-html="$t('drag-documents')"></p>
							</div>
						</div>
					</div>
				</form>
				<form @submit.prevent="create" v-show="fileCount > 0">
					<div
						v-for="(file, index) in files"
						:key="'file-'+index"
						class="field"
					>
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label>
										<a @click.prevent="showPreview(file)">{{file.data.name}}</a>
										<span class="link-icon delete" @click="removeDocument(index);">
											<svg data-v-beffe230="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path data-v-beffe230="" d="M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z" class="A"></path><path data-v-beffe230="" d="M0 0h24v24H0z" class="B"></path></svg>
										</span>
										<span :class="['status', file.status.type? file.status.type: '']" v-show="file.status.message && file.status.message.length">{{file.status.message}}</span>
									</label>
									<div class="element">
										<div class="element-inner">
											<label :for="'name-'+index">{{$t('name')}}</label>
											<input type="text" :placeholder="file.data.name.replace('.pdf','')" v-model="file.name" :id="'name-'+index" :name="'name-'+index">
										</div>
									</div>
									<progress-bar size="big" :val="file.percentCompleted"/>
								</div>
							</div>
						</div>
					</div>
					<hr>
					<div class="container">
						<div class="content">
							<button class="" :disabled="!createEnabled">{{$t('create')}}</button>
						</div>
					</div>
				</form>
			</section>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import ProgressBar from 'vue-simple-progress'

export default {
	data() {
		return {
			files: [],
			createEnabled: true,
		}
	},
	created() {
	},
	computed: {
		fileCount() {
			return this.files.length;
		},
	},
	methods: {
		removeDocument(key){
			this.files.splice(key, 1);
		},
		showPreview(file) {
			let blob = dataURLtoBlob(file.preview);
			downloadFile(blob, file.name);
		},
		handleFilesUpload(input, fieldName, fileList) {
			let self = this;
			/*
			  Set the local file variable to what the user has selected.
			*/
			Array.from(fileList).forEach((file) => {
				/*
				Ensure the file is a pdf file
				*/
				if (/\.(pdf)$/i.test(file.name)) {
					let f = {}
					f.data = file;
					f.preview = '';
					f.name = '';
					f.status = {};

					self.files.push(f);
				}
			});

			/*
			  Generate image previews for the uploaded files
			*/
			this.getImagePreviews();
			input.value = "";
		},
		getImagePreviews(){
			let self = this;
			/*
			Iterate over all of the files and generate an image preview for each one.
			*/
			this.files.forEach((file) => {
				/*
				Ensure the file is an image file
				*/
				if (/\.(pdf)$/i.test(file.data.name)) {
					/*
					Create a new FileReader object
					*/
					let reader = new FileReader();

					/*
					Add an event listener for when the file has been loaded
					to update the src on the file preview.
					*/
					reader.addEventListener('load', function(){
						file.preview = reader.result;
					}.bind(this), false);

					/*
					Read the data for the file in through the reader. When it has
					been loaded, we listen to the event propagated and set the image
					src to what was loaded from the reader.
					*/
					reader.readAsDataURL(file.data);
				}
			});
		},
		create() {
			let self = this;
			self.createEnabled = false;
			self.creationError = false;

			// if (!this.name) {
			// 	this.creationError = true;
			// 	this.$snack.danger(this.$t('compile-all-required-fields'));
			// }

			this.files = this.files.filter(o => !o.status || o.status.type !== 'success');
			this.files.forEach((file, index) => {
				let formData = new FormData();
				let name = file.name.length ? file.name : file.data.name.replace('.pdf','');
				self.$set(file, 'percentCompleted', 0);
				formData.append('name', name);
				formData.append('document', file.data);

				let config = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					onUploadProgress: function(progressEvent) {
						let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
						self.$set(file, 'percentCompleted', percentCompleted);
					},
				};
		  
				if (!this.creationError) {
					axios.post(`/documents/create`, formData, config)
					.then((response) => {
						let message = self.$t('created-successfully');
						self.$set(file.status, 'type', 'success');
						self.$set(file.status, 'message', message);

						// self.$router.push(self.$route.query.redirect || {name: 'documents'});//, params: {id: response.data.response.insertId}});
					})
					.catch((err) => {
						let resp = err.response;
						let message = 'error';
						if (resp.data.response && resp.data.response.duplicate) {
							switch (resp.data.response.duplicate) {
								case 'name':
									message = self.$t('duplicate-name-error');
									break;
							}
						} else {
							message = self.$t('creation-error');
						}
						self.$set(file.status, 'type', 'error');
						self.$set(file.status, 'message', message);

						self.creationError = true;
						if (navigator.vibrate){
							navigator.vibrate([500]);
						}
					})
					.then(() => {
						this.createEnabled = true;
					});
				}
			});
		},
	},
	components: {
		ProgressBar
	}
}
</script>

<style scoped>
.dropbox {
	outline: .2rem dashed grey; /* the dash box */
	outline-offset: -.8rem;
	color: grey;
	background: lightcyan;
	padding: .8rem;
	min-height: 20.0rem; /* minimum height */
	position: relative;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
}

.input-file {
	opacity: 0; /* invisible but it's there! */
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;

	cursor: pointer;
}

.dropbox:hover {
	background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
	font-size: 1.2em;
	text-align: center;
	margin-bottom: 0;
}

.element-inner {
	display: flex;
	align-items: center;
	margin-top: .2rem;
}

.element-inner input {
	margin-top: 0;
}

.element-inner label {
	margin-right: .8rem;
}

.delete {
	/*position: absolute;
	top: 0;
	right: 0;*/
	margin-left: .8rem;
	width: 2.4rem !important;
	height: 2.4rem !important;
}

.delete svg {
	width: 100%;
	height: 100%;
}

.delete path.A {
	fill: var(--primary_color);
}

.delete path.B {
	fill: none;
}

.status {
	border-radius: .3rem;
	padding: 0 .4rem;
	font-size: 1.6rem;
	margin-left: auto;
}

.status.success {
	background-color: var(--success);
	color: #fff;
}

.status.error {
	background-color: var(--error);
	color: #fff;
}
</style>